import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';
import MegaNavigation from './MegaNavigation';

export default class Header {
  constructor(section) {
    this.$el = $(section.el);
    this._bindEvents();
    this.megaNav = new MegaNavigation({ el: this.$el[0] });

    if (window.Pacific.settings.enable_currency_converter) {
      this.currency = section.data.currency;
      this.converter = '[data-currency-converter]';
      this.priceSelector = '.money';
      this.$converter = $(this.converter);
      this._converter();
    }
  }

  _bindEvents() {
    this.events = [
      $('.mobile-header-search-toggle', this.$el).on('click.header', this.toggleSearch),
      $('.header-search-input', this.$el).on('blur.header', this.toggleSearch),
    ];
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.header'));
  }

  _converter() {
    CurrencyConverter.init({
      switcherSelector: this.converter,
      priceSelector: this.priceSelector,
      shopCurrency: this.currency.shop_currency,
      defaultCurrency: this.currency.default_currency,
      displayFormat: this.currency.display_format,
      moneyFormat: this.currency.money_format,
      moneyFormatNoCurrency: this.currency.money_format_no_currency,
      moneyFormatCurrency: this.currency.money_format_currency,
    });

    this._setCurrencyText();

    this.events.push(
      this.$converter.first().on('updateCurrency.header', (event, target) => this._updateCurrency(event, target)),
      this.$converter.on('change.header', (event) => {
        this.$converter.each((index, converter) => {
          if (converter.value !== event.currentTarget.value) {
            converter.value = event.currentTarget.value;
          }
        });

        CurrencyConverter.setCurrency(event.currentTarget.value);
        this._setCurrencyText();
      }),
    );
  }

  _setCurrencyText() {
    // this is unscoped because in mobile view the currency selector is in the footer
    // (outside of this.$el)
    $('.selected-currency').text(this.$converter.val());
  }

  _updateCurrency(event, target) {
    $(this.priceSelector, target).each((index, moneyEl) => {
      CurrencyConverter.update(moneyEl);
    });
  }

  toggleSearch() {
    if (!(document.documentElement.clientWidth > 1020)) {
      const form = $('.header-search-form', this.$el);

      if (form.hasClass('active')) {
        form.removeClass('active');
      }
      form.addClass('active').find('input').focus();
    }
  }

  onSectionUnload() {
    this._unbindEvents();
  }
}
